/*
 * Keeps the video pill in the product gallery pointed at the selected variant.
 *
 * The gallery is not re-rendered when the shopper switches variant - only the
 * product info section is - so the pill is repointed here from a lookup table
 * of every variant that has a `custom.video` metafield.
 */
class ProductMediaVideo extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('[data-card-video-open]');

    const data = this.querySelector('[data-product-video-map]');
    try {
      this.videos = data ? JSON.parse(data.textContent) : {};
    } catch (error) {
      console.error(error);
      this.videos = {};
    }

    if (!this.button || typeof subscribe !== 'function') return;

    this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      const variant = event?.data?.variant;
      this.apply(variant ? this.videos[variant.id] : null);
    });
  }

  disconnectedCallback() {
    this.unsubscribe?.();
  }

  apply(video) {
    if (!video || !video.src) {
      this.button.hidden = true;
      this.button.removeAttribute('data-video-src');
      return;
    }

    this.button.hidden = false;
    this.button.dataset.videoKind = video.kind || 'file';
    this.button.dataset.videoSrc = video.src;

    if (video.poster) {
      this.button.dataset.videoPoster = video.poster;
    } else {
      delete this.button.dataset.videoPoster;
    }
  }
}

if (!customElements.get('product-media-video')) {
  customElements.define('product-media-video', ProductMediaVideo);
}
